import { Controller } from "@hotwired/stimulus"

// Toggles the mobile nav menu open/closed. The page works with this
// controller entirely absent (nav links are just hidden by CSS at narrow
// widths without it) — this only adds the toggle affordance.
//
// It used to own an FAQ underline as well: FAQ and "How it works" shared one
// route, so nav_current lit up "How it works" for both and a hashchange sync
// moved aria-current to FAQ at #faq. FAQ has since left the bar for the
// footer, and with one link on that route the server-rendered aria-current is
// simply right — /how-it-works#faq *is* the How-it-works page.
export default class extends Controller {
  toggle(event) {
    const isOpen = this.element.classList.toggle("is-open")
    event.currentTarget.setAttribute("aria-expanded", isOpen)
  }
}
